var render = function render(){var _vm=this,_c=_vm._self._c;return _c('products',{attrs:{"non_editable":true,"customer-id":_vm.customerId}})
}
var staticRenderFns = []

export { render, staticRenderFns }